/* 囲み付き文字列 */
import React from 'react';
import { convertLine } from '../Convert';

interface Props {
  label: string;
  bold?: boolean;
  color?: string;
  css_class?: string;
}
const EnclosedString: React.FC<Props> = ({ label, bold, color, css_class }) => {
  //太字の規定値
  const bold_css = typeof bold !== 'undefined' && bold === true ? 'font-weight-bold' : '';
  //色の規定色
  color = typeof color === 'undefined' ? 'text-dark' : color;
  // CSSクラスの規定値
  css_class = typeof css_class === 'undefined' ? '' : css_class;

  return (
    <div className="form-row row">
      {/* 改行コードがエスケープされている場合はエスケープなしに置換 */}
      <div className={`p-1 ${bold_css} ${color} ${css_class}`}>{convertLine(label)}</div>
    </div>
  );
};

export default EnclosedString;
